import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Landing from "../Containers/Landing";
import { APP_PAGES } from "../pages";
import Search from "../Containers/Search";
import { CustomerDetails } from "../Containers/CustomerDetails";
import Login from "../Containers/Auth";
import ProtectedRoute from "./ProtectedRoute";
import ResourceListing from "../Containers/Resource";
import Query from "../Containers/Docs/Query";
import Library from "../Containers/Docs/Library";
import Upload from "../Containers/Docs/Upload";
import Detail from "../Containers/Docs/Detail";

const RouteConfig = () => {
  return (
    <Routes>
      <Route
        path={APP_PAGES.DOCS}
        element={
          <ProtectedRoute>
            <Query />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_LIBRARY}
        element={
          <ProtectedRoute>
            <Library />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_UPLOAD}
        element={
          <ProtectedRoute>
            <Upload />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_DETAIL}
        element={
          <ProtectedRoute>
            <Detail />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.CUSTOMERS_HOME}
        element={
          <ProtectedRoute>
            <Landing />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/documents/*"
        element={<Navigate to="/" replace />}
      />
      <Route
        path={APP_PAGES.SEARCH}
        element={
          <ProtectedRoute>
            <Search />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.RESOURCES}
        element={
          <ProtectedRoute>
            <ResourceListing />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.CUSTOMER_DETAILS}
        element={
          <ProtectedRoute>
            <CustomerDetails />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default RouteConfig;
